<template lang="html">
  <div>
    <div class="vx-card user_header">
      <div class="vx-card__header">
        <div class="vx-card__title w-full">
          Users
          <feather-icon 
            icon="DownloadCloudIcon" 
            svgClasses="w-5 h-5 hover:text-danger stroke-current" 
            class="ml-5" 
            :title="$t('ExportList')"
            @click="activePrompt=true"
          />
          
          <router-link
            class="mb-2 mr-1 float-right"
            type="filled"
            color="primary"
            :to="{name: 'CreateUser'}"
          >
            <vs-button color="primary" type="filled">{{$t('Create')}}</vs-button>
          </router-link>
        </div>
      </div>
    </div>

    <vs-prompt :title="$t('ExportToExcel')" class="export-options" @cancle="clearFields" @accept="exportToExcel" accept-text="Export" @close="clearFields" :active.sync="activePrompt">
        <vs-input v-model="fileName" :placeholder="$t('EnterFileName') + '..'" class="w-full" />
        <v-select v-model="selectedFormat" :options="formats" class="my-4" />
        <div class="flex">
          <span class="mr-4">{{('CellAutoWidth')}}:</span>
          <vs-switch v-model="cellAutoWidth">{{('CellAutoWidth')}}</vs-switch>
        </div>
    </vs-prompt>
   
    <vs-table search max-items="10" pagination :data="events">

      <template slot="thead">
        <vs-th sort-key="first_name">{{$t('FirstName')}}</vs-th>
        <vs-th sort-key="last_name">{{$t('LastName')}} </vs-th>
        <vs-th sort-key="email">{{$t('Email')}}</vs-th>
        <vs-th sort-key="id_number">{{$t('IdNumber')}}</vs-th>
        <vs-th sort-key="mobile_number">{{$t('MobileNumber')}}</vs-th>
        <vs-th sort-key="online_status">{{$t('Status')}}</vs-th>
        <vs-th>{{$t('Browser')}}</vs-th>
        <vs-th sort-key="last_visited_page">{{$t('CurrentPage')}}</vs-th>
        <vs-th>{{$t('Actions')}}</vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data">

          <vs-td>{{ tr.first_name }}</vs-td>

          <vs-td>{{ tr.last_name }}</vs-td>

          <vs-td>
            <a @click.prevent.stop :href="'mailto:'+tr.email">{{ tr.email }}</a>
          </vs-td>

          <vs-td>{{ tr.id_number }}</vs-td>

          <vs-td>{{ tr.mobile_number }}</vs-td>

          <vs-td>
            <span style="display: inline-flex">
              <vs-icon :style="{color:isOnline(tr.online_status)?'green':'red','padding-right':'5%'}" icon="fiber_manual_record"></vs-icon>
              {{ tr.online_status }}
              <template v-if='isOnline(tr.online_status)'>({{tr.online_count }})</template>
            </span>
          </vs-td>
          <vs-td>
            <template v-if='isOnline(tr.online_status)'>
              {{ tr.visited_pages_ | browsers }}
            </template>
            <template v-else>-</template>
          </vs-td>
          <vs-td>
            <span v-if='isOnline(tr.online_status)' v-html='filter_visited_pages(tr.visited_pages_)'></span>
            <span v-else>-</span>
          </vs-td>

         <vs-td>
            <router-link
              class="mb-2 mr-1"
              type="filled"
              color="primary"
              :to="{name: 'ViewUser', params: {id: tr.id}}"
            >
            <vs-button class="run_btn" color="success" type="filled">{{$t('View')}}</vs-button>
            </router-link>
          </vs-td>

        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { UAParser } from 'ua-parser-js';


const OnlineStatus = {
  offline: 'Offline',
  online: 'Online'
};
export default {
  components: {
    vSelect
  },
  data: () => ({
    activePrompt: false,
    fileName: '',
    // formats:['xlsx', 'csv', 'txt'],
    formats:['xlsx'],
    cellAutoWidth: true,
    selectedFormat: 'xlsx',
    headerTitle: ['First Name', 'Last Name', 'Email', 'Mobile Number'],
    headerVal: ['first_name', 'last_name', 'email', 'mobile_number'],
    events: [],
    eventhistory_url:"/admin/users/viewhistory/",
  }),
  filters: {
    visited_pages: function(visited_pages) {
      return visited_pages.map(vp => vp.last_visited_page).join('<br/>');
    },
    browsers: function(visited_pages) {
      return visited_pages.map(vp => vp.browser_name).join('\n');
    }
  },
  async mounted(){
    await this.getUserLists();

    const me = this;
    window.Echo.join('useractive')
    .here(user_infos => {
      me.events = me.events.map(user => {
        const ousers = user_infos.filter(ui => ui.user_id == user.id);

        user.online_count = ousers.length;
        user.online_status = user.online_count > 0 ? OnlineStatus.online : OnlineStatus.offline;

        const visited_pages = user.visited_pages
        .map(vp => {
          const ouser = ousers.find(ouser => ouser.browser_identifier == vp.browser_identifier);
          return ouser 
            ? me.mapVisitedPages(Object.assign({user_agent:ouser.user_agent}, vp)) 
            : null;

        }).filter(vp => vp !== null);

        me.$set(user, 'visited_pages_', visited_pages);
        return user;
      });
    })
    .joining(user_info => {
      const user = me.events.find(user => user.id==user_info.user_id);
      if(user){
        user.online_status = OnlineStatus.online
        user.online_count++;

        let visited_page = user.visited_pages.find(vp => vp.browser_identifier == user_info.browser_identifier) 
        
        if(!visited_page) {
          visited_page = {
            browser_identifier: user_info.browser_identifier,
            last_visited_page: '/',
          }
          user.visited_pages.push(visited_page);
        }
        
        if(visited_page) {
          user.visited_pages_.push(
            me.mapVisitedPages(
              Object.assign({user_agent:user_info.user_agent}, visited_page)
            )
          );
        }
      }
    })
    .leaving(user_info => {
      
      const user_idx = me.events.findIndex(user => user.id==user_info.user_id);
      
      if(user_idx > -1){
        const user = me.events[user_idx];
        user.online_count--;

        const vp_idx = user.visited_pages_.findIndex(vp=>vp.browser_identifier == user_info.browser_identifier);
        
        if(vp_idx > -1)
          user.visited_pages_.splice(vp_idx, 1);
        user.online_status = user.online_count > 0 ? OnlineStatus.online : OnlineStatus.offline;
      }
    });
    
    window.Echo.private('userLastVisited')
    .listen('UserLastVisited', response => {
      const user = me.events.find(user => user.id==response.data.user_id);
      if(user) {
        const vp = user.visited_pages_.find(vp=>response.data.browser_identifier == vp.browser_identifier);
        if(vp)
          vp.last_visited_page = response.data.last_visited_page;
      }
    });
  },
  beforeDestroy() {
    window.Echo.leave('useractive');
    window.Echo.leave('userLastVisited')
  },
  methods: {
    isOnline(online_status) {
      return OnlineStatus.online == online_status;
    },
    filter_visited_pages(visited_pages) {
      return visited_pages.map(vp => vp.last_visited_page).join('<br/>');
    },
    mapVisitedPages(vp) {
      if(vp.user_agent) {
        const uaparser = new UAParser(vp.user_agent);
        const browser = uaparser.getBrowser();
        vp.browser_name = browser.name + ' ' + browser.version;
      }
      return vp;
    },
    async getUserLists() {
      this.$vs.loading();
      try{
        const response = await this.$store.dispatch("getUserLists");
        this.$vs.loading.close();
        this.events = response.data.data.map(user => {
          user.online_status = OnlineStatus.offline;
          user.online_count = 0;
          user.visited_pages_ = [];
          return user;
        });
      }catch(error){
        this.$log.error('File : list.vue | Function : getUserLists() | Error :', error);
          this.$vs.loading.close();
          console.error(error);
          // Error response
          this.$vs.notify({
            title: $t("FailedToLoadData"),
            text: error,
            color: "danger",
            position: "top-center"
          });
      }
    },
    exportToExcel () {
      import('@/utils/Export2Excel').then(excel => {
        const list = this.events
        const data = this.formatJson(this.headerVal, list)
        excel.export_json_to_excel({
          header: this.headerTitle,
          data,
          filename: this.fileName,
          autoWidth: this.cellAutoWidth,
          bookType: this.selectedFormat
        })
        this.clearFields()
      })
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        return v[j]
      }))
    },
    clearFields () {
      this.filename = ''
      this.cellAutoWidth = true
      this.selectedFormat = 'xlsx'
    }
  }
}
</script>

<style lang="scss">
  .user_header {
    border-radius: 0 !important;
  }
  .vx-card__title p{
    font-weight: 600 !important;
    font-size: 1.0rem !important;
    padding-bottom: 10px;
  }
  .vx-card__header{
    padding: 1.2rem 1.2rem 0 !important;
  }
  </style>